import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../../../../api/users-api';
import {
  DriveRoles,
  isAbleToSeeUIElement,
} from '../../../../../../utils/roles/client-roles';
import { Messages } from '../../../../../../utils/message-constants';
import SharedToolbar from '../../../../../../shared/shared-toolbar-latest';
import CreateButton from '../../../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../../../shared/buttons/shared-icon-button';
interface SharedDrivesPaginatedGridToolbarProps {
  paginationModel: {
    pageSize: number;
    page: number;
    cursor: string | null;
    search: string;
    driveId: string;
  };
  driveRoles: string[];
  setOpenCreateSharedDriveDialog: Dispatch<SetStateAction<boolean>>;
}

export default function SharedDrivesPaginatedGridToolbar({
  paginationModel,
  driveRoles,
  setOpenCreateSharedDriveDialog,
}: SharedDrivesPaginatedGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          variant="contained"
          disabled={
            !isAbleToSeeUIElement(
              driveRoles,
              DriveRoles.CanCreateSharedDrives.value
            )
          }
          onClick={() => setOpenCreateSharedDriveDialog(true)}
          label="Add Shared Drive"
          tooltipLabel={
            !isAbleToSeeUIElement(
              driveRoles,
              DriveRoles.CanCreateSharedDrives.value
            )
              ? Messages.Errors.Permission.Acting(
                  DriveRoles.CanCreateSharedDrives.value
                )
              : ''
          }
        />
      }
      secondaryButtons={
        <SharedIconButton
          variant="refresh"
          onClick={() => {
            void queryClient.invalidateQueries({
              queryKey: [UserKeys.DriveDocuments],
            });
            void queryClient.invalidateQueries({
              queryKey: [UserKeys.DriveFolders],
            });
            void queryClient.invalidateQueries({
              queryKey: [UserKeys.DrivePermissions],
            });
            void queryClient.invalidateQueries({
              queryKey: [UserKeys.DriveAcls],
            });

            void queryClient.invalidateQueries({
              queryKey: [
                UserKeys.SharedDrivesForDomainPage,
                paginationModel.page,
                paginationModel.pageSize,
                paginationModel.search,
                paginationModel.driveId,
              ],
            });

            void queryClient.invalidateQueries({
              queryKey: [UserKeys.SharedDrivesForUser],
            });

            void queryClient.invalidateQueries({
              queryKey: [UserKeys.SharedDriveFolders],
            });

            void queryClient.invalidateQueries({
              queryKey: [UserKeys.SharedDriveDocuments],
            });
          }}
          tooltipLabel="Refresh"
        />
      }
    />
  );
}
